<template>
  <ul
    class="oct-list"
    :class="[{
      'oct-list--draggable': draggable,
      'oct-list--bordered': border
    }]"
  >
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'OctList',
  props: {
    /** Whether draw border around list items */
    border: {
      type: Boolean,
      default: false
    },
    /** Draggable or not */
    draggable: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-list {
  margin: 0 ;
  width: 100%;
  padding: 0;
  list-style: none;

  &--bordered,
  &--draggable {
    margin-bottom: oct-rem(-16);
  }
}
</style>
